module.exports = __webpack_public_path__ + "img/buddy_whiskers-03.2dc6d79c.svg";